import { Box } from '@mantine/core';
import { MdContent } from './MdContent';

type ResponseBlockProps = {
  text: string;
  /**
   * @desc Whether to stage the answer's arrival (see `rehype-reveal-sections`). Off for a turn
   * rendered from history, which has no arrival — TurnGroup decides, since only it knows whether
   * the answer was already there when the row mounted.
   */
  reveal?: boolean;
};

/**
 * The agent's final answer. It is the one thing in a turn worth composing on arrival, so it is
 * the one place the section reveal is offered at all — see `rehype-reveal-sections`. The
 * animation lives on the section elements themselves, which React keeps across re-renders, so a
 * store update or a thumbs verdict re-renders the answer without replaying it; whether there is
 * an arrival to compose in the first place is TurnGroup's call, via `reveal`.
 */
export function ResponseBlock({ text, reveal = true }: ResponseBlockProps) {
  if (!text) return null;

  return (
    <Box
      /**
       * The seam between a prompt and its answer is the turn's tightest, and it is paid for
       * twice: the column's own `sm` gap, and this. `sm` on top of that put the answer a line
       * and a half below the time under the bubble; 4px brings the pair to one `md` in total.
       */
      pt={4}
      // No bottom padding: the last block's own margin already separates the prose from the
      // action row, and paying for the gap twice pushed the thumbs a whole line clear of the
      // answer they rate.
      pb={0}
      fz="1rem"
      lh={1.7}
    >
      <MdContent text={text} reveal={reveal} />
    </Box>
  );
}
